<attributes-settings-content [attributesResourcesData]="attributesResourcesData"
                             [settings]="settings"
                             (settingsChanged)="settingsChanged.emit($event)">
</attributes-settings-content>
